import HTTPClient from './http-client';

const END_POINT = '/outorgasefluentestotal';

const loadOutorgasEfluentesTotal = async (payload) => {
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  const headers = { headers: { "Content-Type": "application/json" } };
  return api.post(`${END_POINT}`, payload, headers);
}

export {
  loadOutorgasEfluentesTotal,
}
